"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _material = require("@mui/material");
var _NotifyIcon = _interopRequireDefault(require("../NotifyIcon"));
var _elements = require("./elements");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var DialogHeader = function DialogHeader(_ref) {
  var closeButtonProps = _ref.closeButtonProps,
    children = _ref.children,
    className = _ref.className,
    highlightColor = _ref.highlightColor,
    narrow = _ref.narrow,
    onClose = _ref.onClose;
  var theme = (0, _material.useTheme)();
  return /*#__PURE__*/_react["default"].createElement(_elements.StyledMuiDialogHeader, {
    className: className,
    highlight: highlightColor,
    theme: theme,
    narrow: +narrow
  }, /*#__PURE__*/_react["default"].createElement(_elements.StyledHeaderWrapper, {
    theme: theme,
    narrow: narrow
  }, /*#__PURE__*/_react["default"].createElement(_elements.StyledHeader, null, children), onClose ? /*#__PURE__*/_react["default"].createElement(_material.IconButton, _extends({
    "aria-label": "close",
    color: "inherit",
    onClick: onClose
  }, closeButtonProps), /*#__PURE__*/_react["default"].createElement(_NotifyIcon["default"], {
    iconName: "close"
  })) : null));
};
DialogHeader.propTypes = {
  closeButtonProps: _propTypes["default"].shape({}),
  children: _propTypes["default"].node.isRequired,
  className: _propTypes["default"].string,
  narrow: _propTypes["default"].bool,
  highlightColor: _propTypes["default"].string,
  onClose: _propTypes["default"].func
};
DialogHeader.defaultProps = {
  onClose: null,
  highlightColor: null,
  className: '',
  narrow: false,
  closeButtonProps: {}
};
var _default = exports["default"] = DialogHeader;